import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import type { MenuOptionType } from "@dexteel/mesf-core";
import type { Entry } from "../models/Entry";

type Props = {
	onNewEntry: () => void;
	onEditEntry: (entry: Entry) => void;
	onDeleteEntry: (entry: Entry) => void;
};
export const useLogbookEntryOptionsFunctions = ({
	onNewEntry,
	onEditEntry,
	onDeleteEntry,
}: Props) => {
	const getMenuOptions = (data: Entry) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Entry",
				key: "new_logbook_entry",
				onClick: () => onNewEntry(),
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Entry",
					key: "edit_logbook_entry",
					onClick: () => onEditEntry(data),
					icon: <EditIcon />,
				},
				{
					name: "Delete Entry",
					key: "delete_logbook_entry",
					// the row the menu was opened on, not the one open in the viewer
					onClick: () => onDeleteEntry(data),
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
